import gql from 'graphql-tag';

export const CREATE_VECTOR_DOCUMENT = gql`
  mutation CreateVectorDocument(
    $title: String!
    $body: String
    $url: String
    $file: File
    $category: String
    $tags: [String!]
    $applicableContexts: [String!]
    $industryTags: [String!]
    $expertiseLevel: String
    $documentPurpose: String
    $public: Boolean
    $companyWide: Boolean
    $allowedRoles: [String!]
    $expiresAt: ISO8601DateTime
    $citable: Boolean
  ) {
    create_vector_document(
      title: $title
      body: $body
      url: $url
      file: $file
      category: $category
      tags: $tags
      applicableContexts: $applicableContexts
      industryTags: $industryTags
      expertiseLevel: $expertiseLevel
      documentPurpose: $documentPurpose
      public: $public
      companyWide: $companyWide
      allowedRoles: $allowedRoles
      expiresAt: $expiresAt
      citable: $citable
    ) {
      id
      title
      status
      citable
    }
  }
`;

export const UPDATE_VECTOR_DOCUMENT = gql`
  mutation UpdateVectorDocument(
    $id: ID!
    $title: String
    $body: String
    $category: String
    $tags: [String!]
    $applicableContexts: [String!]
    $industryTags: [String!]
    $expertiseLevel: String
    $documentPurpose: String
    $verified: Boolean
    $public: Boolean
    $companyWide: Boolean
    $allowedRoles: [String!]
    $expiresAt: ISO8601DateTime
    $citable: Boolean
  ) {
    update_vector_document(
      id: $id
      title: $title
      body: $body
      category: $category
      tags: $tags
      applicableContexts: $applicableContexts
      industryTags: $industryTags
      expertiseLevel: $expertiseLevel
      documentPurpose: $documentPurpose
      verified: $verified
      public: $public
      companyWide: $companyWide
      allowedRoles: $allowedRoles
      expiresAt: $expiresAt
      citable: $citable
    ) {
      id
      title
      status
      citable
    }
  }
`;

export const DELETE_VECTOR_DOCUMENT = gql`
  mutation DeleteVectorDocument($id: ID!) {
    delete_vector_document(id: $id)
  }
`;

export const PROCESS_URLS = gql`
  mutation ProcessVectorDocumentUrls(
    $urls: [String!]!
    $category: String
    $tags: [String!]
    $public: Boolean
  ) {
    process_vector_document_urls(
      urls: $urls
      category: $category
      tags: $tags
      public: $public
    ) {
      success
      message
      jobId
    }
  }
`;

export const REGENERATE_EMBEDDING = gql`
  mutation RegenerateVectorDocumentEmbedding($id: ID!) {
    regenerate_vector_document_embedding(id: $id) {
      id
      status
    }
  }
`;

export const BULK_IMPORT_DOCUMENTS = gql`
  mutation BulkImportVectorDocuments(
    $files: [File!]!
    $category: String
    $tags: [String!]
    $applicableContexts: [String!]
    $industryTags: [String!]
    $expertiseLevel: String
    $documentPurpose: String
  ) {
    bulk_import_vector_documents(
      files: $files
      category: $category
      tags: $tags
      applicableContexts: $applicableContexts
      industryTags: $industryTags
      expertiseLevel: $expertiseLevel
      documentPurpose: $documentPurpose
    ) {
      id
      title
      status
    }
  }
`;
